import * as React from 'react';
import { useAppContext } from '../../Services/AppContext';
import Form from '../Form/Form';
import FormControl from '../Form/FormControl';
import TextArea from '../Base/TextArea/TextArea';
import SubmitButton from '../Button/SubmitButton';
import ApiClient from '../../Services/ApiClient';
import withForm from '../Form/withForm';
import { useFormContext } from '../Form/FormContext';
import { useState } from 'react';
import FileUpload from '../Base/FileUpload/FileUpload';
import apiClient from '../../Services/ApiClient';
import { v4 as uuidv4 } from 'uuid';
// @ts-ignore
import styles from './CaseChatCreateMessage.module.scss';
import { joinClasses } from '../../Utils/className.util';
import CaseChatCreateMessageFilePreview from './CaseChatCreateMessageFilePreview';
import { User } from '../../graphql/graphql';
import Text from '../Base/Text/Text';
import { PredefinedPhrase } from '../../Modules/PredefinedPhrases/Components/PredefinedPhrasesSetup/PredefinedPhrasesList';
import PredefinedPhraseSelectionModal from '../../Modules/PredefinedPhrases/Components/PredefinedPhraseSelection/PredefinedPhraseSelection/PredefinedPhraseSelectionModal';
import { PhraseType } from '../../graphql/graphql';
import useTranslation from '../../Hooks/useTranslation';
import FirstUpper from '../FirstUpper';

interface CaseChatCreateMessageProps {
	userId: string;
	caseId: string;
	beforeMessage: () => void;
	onMessage: () => void;
	patient?: User;
	patientId: string;
}

const CaseChatCreateMessage = (props: CaseChatCreateMessageProps) => {
	const { translation } = useAppContext();
	const { userId, caseId, onMessage, beforeMessage, patient, patientId } =
		props;
	const { formMethods } = useFormContext();
	const [selectedFile, setSelectedFile] = useState(null);
	const [inputVisible, setInputVisible] = useState(true);
	const [isMenuOpen, setIsMenuOpen] = useState(false);
	const [isPredefinedPhraseSelectionOpen, setIsPredefinedPhraseSelectionOpen] =
		useState(false);
	const { t } = useTranslation();

	const handleLoadPredefinedPhrase = (item: PredefinedPhrase) => {
		setIsPredefinedPhraseSelectionOpen(false);
		formMethods.setValue('message', item.value);
	};

	const handleOpenPredefinedPhraseSelection = () => {
		setIsMenuOpen(false);
		setIsPredefinedPhraseSelectionOpen(true);
	};

	// @ts-ignore
	const handleSendMessage = async values => {
		if (!values.message && !selectedFile) {
			return;
		}

		beforeMessage();

		if (selectedFile) {
			const extReg = /(?:\.([^.]+))?$/;
			const fileExt = extReg.exec(selectedFile.name)[1];
			const fileId = uuidv4();
			const fileIdExt = fileId + '.' + fileExt;

			await ApiClient.put('/cases/' + caseId + '/message', {
				text: fileIdExt,
				sender: userId,
				type: selectedFile.type.search('image/') !== -1 ? 'p' : 'f',
				initial: false,
			});

			const formData = new FormData();
			formData.append('files[]', selectedFile);
			await apiClient.postMultipart(
				'/cases/' + caseId + '/message/' + fileIdExt + '/upload',
				formData,
			);
			formMethods.setValue('file', '');
			setSelectedFile(null);
		}

		if (values.message) {
			await ApiClient.put('/cases/' + caseId + '/message', {
				text: values.message,
				sender: userId,
				type: 'm',
				initial: false,
			});
			formMethods.setValue('message', '');
			setInputVisible(false);
			setInputVisible(true);
		}

		onMessage();
	};

	const handleChangeFile = event => {
		setIsMenuOpen(false);
		setSelectedFile(event.target.files && event.target.files[0]);
	};

	const removeFile = () => {
		setSelectedFile(null);
		formMethods.setValue('file', '');
	};

	return (
		<>
			<Form>
				<CaseChatCreateMessageFilePreview
					removeFile={removeFile}
					selectedFile={selectedFile}
				/>
				<div className={styles.wrapper}>
					{patient?.profile?.languageFormatted && (
						<div className={styles.chatLanguage}>
							<Text tx='base.chatLanguage' firstUpper colon inline />{' '}
							{patient.profile.languageFormatted}
						</div>
					)}
					<div className={styles.inputWrapper}>
						<div
							className={joinClasses([
								'create-case-message__wrapper',
								styles.messageWrapper,
							])}>
							<div className='create-case-message__input-wrapper'>
								<div className='v2-forms'>
									<div className='form-group'>
										{inputVisible && (
											<FormControl
												name={'message'}
												wrapperClassName={''}
												hideRequired={true}>
												<TextArea
													rows={1}
													placeholder={
														translation[
															'component.createCaseMessage.messagePlaceholder'
														]
													}
													wrapperClassName={''}
													className={styles.textArea}
													style={{ paddingRight: '60px' }}
												/>
											</FormControl>
										)}
									</div>
								</div>
							</div>
							<div className='create-case-message__button-wrapper'>
								<SubmitButton
									onSubmit={handleSendMessage}
									className={'create-case-message__button-wrapper__button'}
									title={''}
								/>
							</div>
						</div>
						<div className={styles.subMenu}>
							<div
								className={styles.plusButton}
								onClick={() => setIsMenuOpen(true)}
							/>
							{isMenuOpen && (
								<div className={styles.menu}>
									<div className={styles.inputGroup}>
										<div className={styles.customFile}>
											<FormControl
												label='base.shared.pickFile'
												name={'file'}
												onChange={handleChangeFile}
												wrapperClassName={styles.fileUpload}>
												<FileUpload id={'chat-upload-file'} />
											</FormControl>
											<label
												className={styles.attachment}
												htmlFor='chat-upload-file'>
												<FirstUpper>{t('base.shared.pickFile')}</FirstUpper>
											</label>
										</div>
									</div>
									<div
										className={styles.phrasesButton}
										onClick={handleOpenPredefinedPhraseSelection}>
										<div className={styles.icon} />
										<Text tx='base.predefinedPhrases' />
									</div>
									<div
										className={styles.close}
										onClick={() => setIsMenuOpen(false)}
									/>
								</div>
							)}
						</div>
						{isPredefinedPhraseSelectionOpen && (
							<PredefinedPhraseSelectionModal
								isOpen
								type={PhraseType.Chat}
								onSelect={handleLoadPredefinedPhrase}
								onClose={() => setIsPredefinedPhraseSelectionOpen(false)}
							/>
						)}
					</div>
				</div>
			</Form>
		</>
	);
};

export default withForm(CaseChatCreateMessage);
